module.exports = __webpack_public_path__ + "static/img/ldleft.8036dd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/ldleft.png
// module id = incV
// module chunks = 0